import React, { useState, useEffect } from "react";
import "../components/PerfilEmpleado.css";
import axios from "axios";
import noProfile from "../assets/No_Profile.jpg";
import { toast } from "react-toastify";
import PageTitle from "../components/PageTitle";

const API_URL = `${process.env.REACT_APP_API_URL}/api/users`;

const getStoredToken = () =>
  localStorage.getItem("token") || sessionStorage.getItem("token");

const getStoredUser = () => {
  const raw =
    localStorage.getItem("user") || sessionStorage.getItem("user");
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

function PerfilEmpleado() {
  const [user, setUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [passError, setPassError] = useState("");

  // 🟣 Obtener el usuario actual desde el backend
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let didSucceed = false; // 👈 para saber si alguna vez cargó bien

    const token = getStoredToken();
    const stored = getStoredUser();
  
    if (!token) {
      console.warn("No hay token guardado.");
      setLoading(false);
      return;
    }
  
    // (opcional) pinta algo rápido mientras llega el backend
    if (stored) setUser(stored);
  
    axios
      .get(`${API_URL}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        didSucceed = true;
        setUser(res.data);
      })
      .catch((err) => {
        // ✅ Si ya cargó (por stored o por una llamada previa), NO muestres toast
        if (didSucceed || stored) return;
  
        // ✅ Ignorar requests cancelados (pasa mucho en dev / StrictMode)
        if (axios.isCancel?.(err) || err.code === "ERR_CANCELED") return;
  
        console.error("Error al obtener perfil:", err);
        toast.error("No se pudo cargar el perfil");
      })
      .finally(() => setLoading(false));
  }, []);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    if (newPass.length < 6) {
      setPassError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (newPass !== confirmPass) {
      setPassError("Las contraseñas no coinciden.");
      return;
    }

    try {
      const token = getStoredToken();
      const res = await axios.put(
         `${process.env.REACT_APP_API_URL}/api/users/change-password`,
        { actual: currentPass, nueva: newPass },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(res.data.message || "Contraseña actualizada correctamente");
      setShowModal(false);
      setCurrentPass("");
      setNewPass("");
      setConfirmPass("");
      setPassError("");
      } catch (error) {
      const msg =
        error.response?.data?.message ||
      "Error al cambiar la contraseña. Intenta nuevamente.";
      setPassError(msg);
    }
};


  return (

    <>

    <PageTitle title="Perfil" />

    <div className="perfil-root">
      <div className="perfil-page">
        <h1 className="perfil-title">Mi Perfil</h1>

        {loading ? (
          <p>Cargando perfil...</p>
        ) : !user ? (
          <p>No se pudo cargar el perfil.</p>
        ) : (
          <div className="perfil-card">
            {/* === Parte superior === */}
            <div className="perfil-top">
              <div className="perfil-avatar">
                <img src={user.foto || noProfile} alt="Foto de perfil" />
              </div>

              <div className="perfil-main">
                <h2 className="perfil-name">{user.nombre}</h2>
                <div className="perfil-estado">
                  <span className={user.activo ? "badge activo" : "badge inactivo"}>
                    Estado actual: {user.activo ? "Activo" : "Inactivo"}
                  </span>
                </div>
              </div>
            </div>

            {/* === Información personal === */}
            <div className="perfil-body">
              <div className="fila">
                <div className="label">Identificación</div>
                <div className="valor">{user.documento}</div>
              </div>

              <div className="fila">
                <div className="label">Correo</div>
                <div className="valor">{user.correo}</div>
              </div>

              <div className="fila">
                <div className="label">Celular</div>
                <div className="valor">{user.telefono?.trim() ? user.telefono : "—"}</div>
              </div>

              <div className="fila">
                <div className="label">Área</div>
                <div className="valor">{user.area?.trim() ? user.area : "—"}</div>
              </div>

              <div className="fila">
                <div className="label">Cargo</div>
                <div className="valor">{user.cargo?.trim() ? user.cargo : "—"}</div>
              </div>

              <div className="fila">
                <div className="label">Tipo de perfil</div>
                <div className="valor">{user.rol}</div>
              </div>
            </div>

            {/* === Acciones === */}
            <div className="perfil-actions">
              <button className="btn-accion primary" onClick={() => setShowModal(true)}>
                Cambiar contraseña
              </button>
            </div>
          </div>
        )}
      </div>

      {/* === Modal contraseña === */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Cambiar Contraseña</h3>
            <form onSubmit={handlePasswordSubmit} className="modal-form">
              <label>Contraseña actual</label>
              <input
                type="password"
                value={currentPass}
                onChange={(e) => setCurrentPass(e.target.value)}
                required
              />

              <label>Nueva contraseña</label>
              <input
                type="password"
                value={newPass}
                onChange={(e) => setNewPass(e.target.value)}
                required
              />

              <label>Confirmar nueva contraseña</label>
              <input
                type="password"
                value={confirmPass}
                onChange={(e) => setConfirmPass(e.target.value)}
                required
              />

              {passError && <div className="pass-error">{passError}</div>}

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>

    </>
    
  );
}

export default PerfilEmpleado;
